<template>
    <div class="d-flex flex-column">
        <template v-if="agreementChecked">
            <!--    人脸登录确认部分-->
            <template v-if="this.needConfirmAgreement">
                <div class="d-flex flex-column align-items-center justify-content-center text-center">
                    <div class="camera d-flex"></div>
                    <div class="w-100 d-flex justify-content-center">
                        <b-form-checkbox id="checkbox-1" @change="confirmAccept"
                                         :disabled="this.queryAgreementListLoading">
                            我已充分知悉、理解并同意
                            <agreement-list :queryAgreementListLoading="queryAgreementListLoading"
                                            :agreementList="this.agreementList"/>
                            的全部内容
                        </b-form-checkbox>
                    </div>
                </div>
            </template>
            <!--        人脸登录扫脸部分-->
            <template v-else>
                <face-recognize v-if="useFaceRecognize" ref="recognize" style="height: 225px !important;"
                                @user-identified="userIdentified"></face-recognize>
                <div v-else class="mt-5">
                    <FaceCamera ref="camera" @user-identified="userIdentified"></FaceCamera>
                </div>
                <b-form-checkbox v-if="identifyFor==='toWork'" v-model="useFaceRecognize" name="check-button" switch>
                    使用本地人脸识别服务：<b>{{ useFaceRecognize ? '开启' : '关闭' }}</b>
                </b-form-checkbox>
            </template>
        </template>
        <loading_1 v-else></loading_1>
    </div>

</template>

<script>
import emCommonApiMixin from "@/mixin/em/common/api";
import FaceCamera from "@/components/Face/FaceCamera";
import AgreementList from "@/components/em/login/AgreementList";
import FaceRecognize from "@/components/Face/FaceRecognize.vue";
import loading_1 from "@/components/common/display/Loading_1.vue";

export default {
    name: "FaceLogin",
    mixins: [emCommonApiMixin],
    components: {loading_1, FaceRecognize, FaceCamera, AgreementList},
    props: {
        usingFace: {
            type: Boolean
        },
        identifyFor: String
    },
    data() {
        return {
            confirmed: false,
            cameraOpened: false,
            agreementList: [],
            queryAgreementListLoading: false,
            agreementChecked: false,//是否检查过协议

            useFaceRecognize: true,
        }
    },
    created() {
        this.queryAgreementList()
    },
    watch: {
        needConfirmAgreement: {
            handler() {
                this.openFromOutside();
            },
            immediate: true
        },
        useFaceRecognize() {
            this.openFromOutside();
        },
    },
    computed: {
        agreementIsEmpty() {
            return this.agreementList.length === 0
        },
        needConfirmAgreement() {
            // 需要同意的场景：1.协议不为空 2.协议未确认过
            return !this.agreementIsEmpty && !this.confirmed;
        },
    },
    methods: {
        confirmAccept() {
            this.confirmed = true;
            this.cameraOpened = true
            this.$emit('camera-opened', true);
        },
        queryAgreementList() {
            this.queryAgreementListLoading = true
            this.$_emApiMixin_post(this.$_emApiMixin_entityBaseApi('sithMesAgreement') + "/findByBusinessModuleCode?code=" + "face_camera", {}).then(response => {
                    this.agreementList = response.data;
                    if (this.agreementIsEmpty) {
                        this.confirmed = true;
                        this.cameraOpened = true
                        this.$emit('camera-opened', true);
                    }
                }
            ).finally(() => {
                this.queryAgreementListLoading = false;
                this.agreementChecked = true;
            })
        },
        userIdentified(userId) {
            this.$emit('user-identified', userId);
        },
        reset() {
            this.cameraOpened = false
            this.confirmed = false;
            if (this.useFaceRecognize) {
                if (this.$refs.recognize) {
                    this.$refs.recognize.closeVideo();
                }
            } else if (this.$refs.camera) {
                this.$refs.camera.closeVideo();
            }
            this.$emit('camera-opened', false);
        },
        openFromOutside() {
            if (this.agreementChecked && !this.needConfirmAgreement) {
                this.$nextTick(() => {
                    if (this.useFaceRecognize) {
                        this.$refs.recognize.startRecognize();
                    } else {
                        this.$refs.camera.openVideo()
                    }
                });
            }
        },
    },
}
</script>

<style scoped>
.agreement {
    justify-content: center;
}

.camera {
    width: 210px;
    height: 180px;
    background: url("../../../assets/images/camera-flash.png");
}

::v-deep .custom-control-label {
    min-width: 335px !important;
}
</style>
